import React from "react";

import Video from "../components/Video";

import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const videos = [
  {
    source: "reklama1",
    title1: "reklama1",
    route: "holofit",
    img: "/images/naslovneVideo/holofit_ver.png",
    key: 1,
  },
  {
    source: "reklama2",
    title1: "reklama2",
    route: "dmus",
    img: "/images/naslovneVideo/dmus_ver.png",
    key: 2,
  },
];

const Reklame = () => {
  return (
    <div name="home">
      <Swiper
        modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
        slidesPerView={1}
        loop
        speed={1000}
        autoplay={{ delay: 35000, disableOnInteraction: false }}
        className="swiper"
        navigation
        // pagination={{ clickable: true }}
      >
        {videos.map((video) => (
          <SwiperSlide key={video.key}>
            <Video video={video} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Reklame;
